<div id="change-password">

  @if (user.passwordExpired) {
    <h2 i18n>Reset Password</h2>
    <p i18n>Your password has expired, please set a new password to continue.</p>
  } @else {
    <h2 i18n>Change Password</h2>
  }
  <p i18n>Please make sure your password conforms to the secure password complexity policy:</p>
  <div i18n>
    <p class="py-0 my-0">Minimum 14 characters long</p>
    <p class="py-0 my-0">Contains at least 1 upper case letter,</p>
    <p class="py-0 my-0">Contains at least 1 lower case letter,</p>
    <p class="py-0 mt-0">Contains at least 1 special character</p>
  </div>

  <form (submit)="save()" [formGroup]="form" >

    <p-inputgroup>
      <p-inputgroup-addon>
        <i class="pi pi-key"></i>
      </p-inputgroup-addon>
      <input
        pInputText
        id="new-password"
        name="newPassword"
        type="password"
        maxlength="50"
        formControlName="newPassword"
        (keyup.enter)="save()"
        aria-label="newPassword"
        aria-describedby="password-help"
        placeholder="New password"/>
    </p-inputgroup>
    <p-inputgroup>
      <p-inputgroup-addon>
        <i class="pi pi-key"></i>
      </p-inputgroup-addon>
      <input
        pInputText
        id="confirm-password"
        name="confirmPassword"
        type="password"
        maxlength="50"
        (keyup.enter)="save()"
        formControlName="confirmPassword"
        aria-label="Confirm password"
        aria-describedby="password-help"
        placeholder="Confirm password" />
    </p-inputgroup>


    @switch(messageType) {
      @case('PASSWORD_NO_MATCH') {
        <p-message severity="error" closable i18n>Please make sure the passwords match!</p-message>
      }
      @case('PASSWORD_INVALID') {
        <p-message severity="error" closable i18n>Please make sure the password matches the Password Policy!</p-message>
      }
      @case ('FORM_INVALID') {
        <p-message severity="error" closable i18n>There are problems with your submission. Please address the fields highlighted in red</p-message>
      }
      @case ('ERROR_SAVING') {
        <p-message severity="error" closable i18n>An error occurred while saving your changes. Please try again.</p-message>
      }
      @case ('PASSWORD_CHANGED') {
        <p-message severity="success" i18n>Password changed!</p-message>
      }
    }
    <button class="p-button form-btn gap-2" (click)="save()">Change Password</button>
  </form>
</div>
